<template lang="html">
  <div class="vip-head">
    <slot name="bg"></slot>
    <div class="vip-head-dia">
      <img src="./images/dia.png" v-if="isBuy" alt="">
      <img src="./images/dia-no.png" v-else alt="">
    </div>
    <div class="vip-head-info">
      <slot name="userPic"></slot>
      <p><slot name="userName"></slot></p>
    </div>
    <!--<div class="vip-head-info"></div>-->
    <div class="vip-head-into">
      <slot name="endDate"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VipHead',
    props: ['isBuy']
  }
</script>

<style lang="scss" scoped>
  @charset "UTF-8";
  @import "../../style/main";

  .vip-head {
    width: 100%;
    position: relative;
    min-height: rem(246);
    &-bg {
      width: 100%;
    }
    &-dia {
      position: absolute;
      top: rem(60);
      right: rem(90);
      > img {
        width: rem(102);
      }
    }
    &-info {
      position: absolute;
      top: rem(70);
      left: rem(86);
      height: rem(90);
      display: flex;
      align-items: center;
      img {
        width: rem(90);
        border-radius: 100%;
      }
      p {
        font-size: rem(32);
        font-weight: bolder;
        color: #735033;
        margin-left: rem(20);
      }
    }
    &-into {
      position: absolute;
      top: rem(200);
      left: rem(75);
      font-size: rem(26);
      color: #683913;
    }
  }
</style>
